import type { ReactNode } from 'react';

export interface ProductTileProps {
  image?: ReactNode;
  productInfo?: ReactNode;
  children?: ReactNode;
  ctaButton?: ReactNode;
}

export const ProductTile = ({ image, productInfo, children, ctaButton }: ProductTileProps) => (
  <div className="w-full border py-5 px-8 mb-8 flex flex-col">
    <div className="w-full flex flex-row items-center mb-6">
      <div className="w-full flex flex-row items-center">
        {image && <div className="flex justify-center w-[40%] p-6">{image}</div>}
        {productInfo && <div className="flex flex-col ml-3">{productInfo}</div>}
      </div>
    </div>
    <div className="w-full flex flex-col px-2">{children}</div>
    {ctaButton && <div className="mt-6">{ctaButton}</div>}
  </div>
);
